/**
 * Compose up-to-2-char initials from a free-form display name; `''` when
 * empty. Shared by `<ZoomPanel>` (§2 video-frame avatars) and
 * `<ZoomPanelPreJoin>` (pre-join patient avatar) so the two surfaces can't
 * drift apart.
 */
export function initialsOf(name?: string): string {
  if (!name) return ''
  return name
    .trim()
    .split(/\s+/)
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase()
}
